import axios from 'axios';
import * as _ from 'lodash'

class TollService {

  /**
   * Retorna as pracas de pedagio de um estado
   *
   * @returns Promise<Object> pracas
   */
   getTollsByState(state) {
     return axios
       .get(`/v1/getTolls/${state}`)
       .then(res => {
         return res.data;
       })
   }

   getListTolls() {
     return axios
       .get(`/v2/getListTolls`)
       .then(res => {
         // return res.data;
         // if (res.data.status.code == 0) {
           res.data.forEach(function (o) {
             if (o.state == 'BA') {
               o.state = 'BAHIA';
             } else if (o.state == 'ES') {
               o.state = 'ESPIRITO SANTO';
             } else if (o.state == 'GO') {
               o.state = 'GOIÁS';
             } else if (o.state == 'MG') {
               o.state = 'MINAS GERAIS';
             } else if (o.state == 'MS') {
               o.state = 'MATO GROSSO DO SUL';
             } else if (o.state == 'MT') {
               o.state = 'MATO GROSSO';
             } else if (o.state == 'PE') {
               o.state = 'PERNAMBUCO';
             } else if (o.state == 'PR') {
               o.state = 'PARANÁ';
             } else if (o.state == 'PA') {
               o.state = 'PARÁ';
             } else if (o.state == 'RJ') {
               o.state = 'RIO DE JANEIRO';
             } else if (o.state == 'RS') {
               o.state = 'RIO GRANDE DO SUL';
             } else if (o.state == 'SC') {
               o.state = 'SANTA CATARINA';
             } else if (o.state == 'SP') {
               o.state = 'SÃO PAULO';
             }
               else if (o.state == 'PI') {
               o.state = 'PIAUÍ';
             }
           });
           return res.data;
         // }
         // else {
         //   return res.data.status;
         // }
       })
   }

  getStatePercent(state) {
    return axios
      .get(`/v1/getStatePercent`)
      .then(res => {
        return res.data;
      })
  }


  getTolls(){
    return axios
    .get(`/v2/routing/getTolls`).then(res => {
      return res.data;
    })

  }

  getPriceTolls(request){
    return axios
    .post(`/v2/routing/getTollsPrice`, request).then(res => {
      return res.data;
    })

  }

  getValePedagio(contractId){
    return axios
    .get(`/v2/vp/list/` + contractId).then(res => {
      return res.data;
    })
  }

  getById(idVP){
    return axios
    .get(`/v2/vp/getById/` + idVP).then(res => {
      return res.data;
    })
  }

  insertValePedagio(request){
    return axios
    .post(`/v2/vp/inserirValePedagio`, request).then(res => {
      return res.data;
    })
  }

  getFilter(filter){
    return axios
    .post(`/v2/vp/filter`, filter).then(res => {
      return res.data;
    })
  }

  getFilterLimited(filter){
    return axios
    .post(`/v2/vp/filterLimited`, filter).then(res => {
      return res.data;
    })
  }

  getInfo(){
    return axios
    .get(`/v2/vp/getInfo`).then(res => {
      return res.data;
    })
  }

  getSaldoVeiculo(plate){
    return axios
    .get(`/v2/vp/getSaldoVeiculo/`+ plate).then(res => {
      return res.data;
    })
  }

  cancelar(req){
    return axios
    .post(`/v2/vp/cancelar`, req).then(res => {
      return res.data;
    })
  }

  transferirEmbarcador(request){
    return axios
    .post(`/v2/vp/transferirEmbarcador`, request).then(res => {
      return res.data;
    });
  }

  getTransfer(transferId){
    return axios
     .get(`/v2/vp/getTransfer/`+ transferId).then(res => {
       return res.data;
     })
  }

  exportarRelatorioAcompanhamento(req) {
    let config = { responseType: "blob" };
    return axios.post('/v2/vp/exportarRelatorioAcompanhamento', req, config).then(res => {
      return res.data;
    });
  }

  exportarRelatorioCompleto(filter) {
    let config = { responseType: "blob" };
    return axios
     .post(`/v2/vp/exportarExtratoCompletoVP/`, filter, config).then(res => {
       return res.data;
     });
  }

  exportarRelatorioParent(filter) {
    let config = { responseType: "blob" };
    return axios
     .post(`/v2/vp/exportarRelatorioAcompanhamentoParent/`, filter, config).then(res => {
       return res.data;
     });
  }

  getVehicleDataVp(plate, document) {
    const queryParams = document ? '?cpfCnpj=' + document: '';
    // CASO NÃO INFORMADO A PLACA, ENVIA 'NOTPLATE' PARA NÃO QUEBRAR O SERVIÇO
    return axios.get(`/v2/getVehicleDataSiteVP/${plate || 'NOTPLATE'}${queryParams}`).then(res => res.data.vehicle);
  }

  cadastrarExcecao(request) {
    return axios.post(`/v2/vp/site/criarExcecaoRntrc`, request).then(res => res.data);
  }

  exportReceiptVp(req) {
    let config = { responseType: "blob" };
    return axios.post('/v2/vp/exportReceiptVP', req, config).then(res => {
      return res.data;
    });
  }
}

// Singleton
const instance = new TollService();
export default instance;



// WEBPACK FOOTER //
// ./src/services/toll.js